export default __webpack_public_path__ + "static/media/spin-cas.1c3e301b.svg";